import { empty, filter, map, of, switchMap, withLatestFrom } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { notificationActions, NotificationType } from '@content-platform/web-angular-shared-ui-notifications';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { errorActions } from '../actions';
import { WebAngularSharedUtilErrorHandlingConfig } from '../error-handling-config';
import { ErrorDispatchService } from '../error-dispatch.service';
import { ROUTER_CANCEL } from '@ngrx/router-store';
import { getHasError } from '../selectors/error.selectors';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@ngrx/effects";
import * as i3 from "@content-platform/web-angular-shared-util-logging";
import * as i4 from "../error-dispatch.service";
import * as i5 from "@angular/router";
/**
 * The error effects
 *
 */
export class ErrorEffects {
    constructor(store, errorActions$, loggerService, errorHandlingOptions, errorDispatchService, router) {
        this.store = store;
        this.errorActions$ = errorActions$;
        this.errorHandlingOptions = errorHandlingOptions;
        this.errorDispatchService = errorDispatchService;
        this.router = router;
        this.add$ = createEffect(() => this.errorActions$.pipe(ofType(errorActions.ADD_ERROR), map((action) => action.payload), switchMap((error) => {
            this.logger.error(error.message, { source: error.source });
            if (error.redirect) {
                const route = this.errorDispatchService.getRedirectRoute(error);
                if (route) {
                    this.router.navigate([route]);
                }
            }
            if (error.showNotification &&
                (this.errorHandlingOptions.showNotificationOnRouteTransition ||
                    (this.router.url !== this.errorHandlingOptions.errorRedirectRoute &&
                        this.router.url !== '/error' &&
                        this.router.url !== '/'))) {
                return of(new notificationActions.Open(this.getNotificationObject(error)));
            }
            else {
                return empty();
            }
        })));
        this.routeFailed$ = createEffect(() => this.errorActions$.pipe(ofType(ROUTER_CANCEL), map((action) => action.payload), withLatestFrom(this.store.pipe(select(getHasError))), map(([, hasError]) => {
            if (hasError &&
                !this.errorHandlingOptions.doNotRedirectOnErrorGuard &&
                this.router.url === '/') {
                this.router.navigate([this.errorHandlingOptions.errorRedirectRoute || '/error']);
            }
        })), { dispatch: false });
        this.handleAllFailActions$ = createEffect(() => this.errorActions$.pipe(filter(action => action &&
            action.type.toUpperCase().includes('FAIL') &&
            this.errorHandlingOptions.handleAllFailActions &&
            action.isFailAction), map((action) => action.payload), switchMap((error) => of(new errorActions.Add(error)))));
        this.logger = loggerService.instance('NgrxErrorHandler');
    }
    getNotificationObject(error) {
        return {
            type: NotificationType.Error,
            inputs: {
                props: {
                    message: error.message,
                    button: {
                        label: 'Dismiss',
                        action: () => this.store.dispatch(new errorActions.Remove(error))
                    }
                }
            }
        };
    }
    static { this.ɵfac = function ErrorEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorEffects)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.Actions), i0.ɵɵinject(i3.LoggerService), i0.ɵɵinject(WebAngularSharedUtilErrorHandlingConfig), i0.ɵɵinject(i4.ErrorDispatchService), i0.ɵɵinject(i5.Router)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ErrorEffects, factory: ErrorEffects.ɵfac }); }
}
//# sourceMappingURL=error.effects.js.map